// src/components/Layout/Menu.jsx

import React from "react";
import styles from "./Menu.module.css";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  useGetUsersQuery,
  useLogoutMutation,
} from "../../redux/slices/usersApiSlice";
import { logout } from "../../redux/slices/authSlice";
import {
  FaChevronRight,
  FaListAlt,
  FaUser,
} from "react-icons/fa";
import { toast } from "react-toastify";
import { IoMdExit } from "react-icons/io";
import { sortByName } from "../../utils/items";

const Menu = ({ selectedUser, setSelectedUser, setView }) => {
  const { userInfo } = useSelector((state) => state.auth);
  const isAdmin = userInfo?.isSuperAdmin;

  // Admin ise tüm kullanıcıları çek
  const { data: users } = useGetUsersQuery(null, {
    skip: !isAdmin,
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [logoutApiCall] = useLogoutMutation();

  // Aktif buton seçili şehirden türetilir (Şehir Takibi ekranından seçimde de vurgulansın)
  const activeButton = selectedUser || "dashboard";

  const handleLogout = () => {
    toast(
      ({ closeToast }) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <p>Çıkış yapmak istediğinize emin misiniz?</p>
          <div style={{ display: "flex", gap: "10px" }}>
            <button
              onClick={() => confirmLogout(closeToast)}
              className={styles.confirmButton}
            >
              Evet
            </button>
            <button onClick={closeToast} className={styles.cancelButton}>
              Hayır
            </button>
          </div>
        </div>
      ),
      {
        position: "top-right",
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
        className: styles.toastContainer,
      }
    );
  };

  const confirmLogout = async (closeToast) => {
    try {
      await logoutApiCall().unwrap();
      dispatch(logout());
      navigate("/login");
    } catch (err) {
      console.error(err);
    }
    closeToast();
  };

  // Dashboard butonuna tıklanınca "dashboard" aktif
  const handleDashboardClick = () => {
    setSelectedUser(null);
    setView("all");
  };

  // Kullanıcı butonuna tıklanınca "user._id" aktif
  const handleUserClick = (userId) => {
    setSelectedUser(userId);
    setView("all");
  };

  return (
    <div className={styles.container}>
      <div className={styles.menuItems}>
        {/* Dashboard Button */}
        <button
          className={
            activeButton === "dashboard"
              ? styles.menuBtnsActive
              : styles.menuBtns
          }
          onClick={handleDashboardClick}
        >
          <div className={styles.btnRightBox}>
            <FaListAlt /> Dashboard
          </div>
          <FaChevronRight />
        </button>

        {/* Sadece admin ise normal kullanıcıları listeleriz. */}
        {isAdmin &&
          sortByName(users || [])
            .filter((u) => !u.isSuperAdmin) // superadmin olmayanlar
            .map((user) => (
              <button
                key={user._id}
                className={
                  activeButton === user._id
                    ? styles.menuBtnsActive
                    : styles.menuBtns
                }
                onClick={() => handleUserClick(user._id)}
              >
                <div className={styles.btnRightBox}>
                  <FaUser style={{ marginRight: 5 }} />
                  {user.name}
                </div>
                <FaChevronRight />
              </button>
            ))}
      </div>

      {/* Logout Button */}
      <div className={styles.logoutContainer}>
        <button className={styles.logoutBtn} onClick={handleLogout}>
          <div className={styles.btnRightBox}>
            <IoMdExit /> Çıkış yap
          </div>
          <FaChevronRight />
        </button>
      </div>
    </div>
  );
};

export default Menu;
